import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { routeNode } from 'core/routing';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { FourOhFour } from 'apps/fourOhFour';

import { FilesAndDirectoryPage } from 'apps/project/tabs/files/FilesAndDirectoryPage';

const viewsMap = {
  '': FilesAndDirectoryPage,
  directory: FilesAndDirectoryPage,
};

@observer
export class FilesSpace extends React.Component {
  render() {
    const { params, project, projectManager, repoManager, componentFromRoute } =
      this.props;
    const View = componentFromRoute();
    return (
      <MainWrapper>
        <View
          params={params}
          project={project}
          projectManager={projectManager}
          repoManager={repoManager}
        />
      </MainWrapper>
    );
  }
}

FilesSpace.propTypes = {
  componentFromRoute: PropTypes.func,
  params: PropTypes.object,
  project: PropTypes.object,
  projectManager: PropTypes.object,
  repoManager: PropTypes.object,
};

export const ProfileFilesRouter = routeNode(
  'profile.project.files',
  viewsMap,
  FourOhFour,
)(FilesSpace);

export const ProfileFilesVersionRouter = routeNode(
  'profile.project.version.files',
  viewsMap,
  FourOhFour,
)(FilesSpace);

export const InitiativeFilesRouter = routeNode(
  'initiative.project.files',
  viewsMap,
  FourOhFour,
)(FilesSpace);

export const InitiativeFilesVersionRouter = routeNode(
  'initiative.project.version.files',
  viewsMap,
  FourOhFour,
)(FilesSpace);
